import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-top-nav-registration',
    templateUrl: './top-nav-registration.component.html',
    styleUrls: ['./top-nav-registration.component.scss'],
    standalone: false
})
export class TopNavRegistrationComponent {

  @Input() llttfPage=false;
}
